import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const getTrades = async (params = {}) => {
  const { 
    page = 1, 
    url: customUrl,
    top_volume_24h = false,
    top_trades = false,
    top_pnl = false,
  } = params;
  
  if (customUrl) {
    return await fetchData(customUrl);
  }
  
  let url = `${backendUrl}/api/polymarket/trades/?page=${page}`;
  
  const queryParams = [];
  
  if (top_volume_24h) queryParams.push('top_volume_24h=True');
  if (top_trades) queryParams.push('top_trades=True');
  if (top_pnl) queryParams.push('top_pnl=True');

  if (queryParams.length > 0) url += `&${queryParams.join('&')}`;
  
  return await fetchData(url);
};

// Вынесенная функция для выполнения запроса
const fetchData = async (url) => {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении торговых операций: HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Программная ошибка получения торговых операций:', error);
    throw error;
  }
};